import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AsyncPipe, Location} from '@angular/common';
import {UserService} from "../../../services/user.service";
import {Utils} from "../../Utils";
import {Router} from "@angular/router";
import {SharedService} from "../../../services/shared.service";
import {Observable, Subscription} from "rxjs";
import {IndexedDbService} from "../../../services/indexed-db.service";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.css',
  imports: [
    AsyncPipe
  ],
  standalone: true
})
export class NavbarComponent implements OnInit, OnDestroy {
  @Input() showHomeButton!: boolean;
  private dataSubscription: Subscription;
  titleToShow!: string;
  fullname!: string | null;
  $edlInfo!: Observable<any>;
  utils: Utils = new Utils();

  constructor(private location: Location, private userService: UserService, private router: Router, private sharedService: SharedService, private indexedDbService: IndexedDbService) {
  }

  async ngOnInit(): Promise<void> {
    await this.getUserFullname();
    this.setTitleToShow();

    this.dataSubscription = this.sharedService.data$.subscribe(isUserLoaded => {
      if (isUserLoaded) {
        this.getUserFullname().then();
      }
    });

    this.$edlInfo = this.sharedService.edlInfo$
  }


  setTitleToShow(): void {
    switch (this.location.path()) {
      case '/':
        this.titleToShow = '';
        break;
      default:
        this.titleToShow = 'Accueil';
        break;
    }
  }

  async getUserFullname() {
    try {
      this.fullname = await this.userService.getUserFullname() as string;
    } catch (error) {
      console.error('Error retrieving fullname from IndexedDB', error);
      this.fullname = null; // Set fullName to null in case of error
      await this.getUserFullname();
    }
  }

  async onLogout() {
    try {
      this.router.navigate(['/login']).then();
      await this.indexedDbService.deleteDatabase();
    } catch (error) {
      console.error('Could not logout', error);
    }
  }


  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }

}
